import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SchoolsState {
  schools: any[];
  selectedSchool: any;
  schoolLevels: any[];
  schoolTypes: any[];
  schoolOwners: any[];
  filters: {
    search: string;
    district?: number;
    schoolLevel?: number;
    schoolType?: number;
    isActive?: boolean;
  };
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
}

const initialState: SchoolsState = {
  schools: [],
  selectedSchool: null,
  schoolLevels: [],
  schoolTypes: [],
  schoolOwners: [],
  filters: {
    search: '',
  },
  pagination: {
    page: 1,
    pageSize: 20,
    total: 0,
  },
};

const schoolsSlice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    setSchools: (state, action: PayloadAction<any[]>) => {
      state.schools = action.payload;
    },
    setSelectedSchool: (state, action: PayloadAction<any>) => {
      state.selectedSchool = action.payload;
    },
    setSchoolLevels: (state, action: PayloadAction<any[]>) => {
      state.schoolLevels = action.payload;
    },
    setSchoolTypes: (state, action: PayloadAction<any[]>) => {
      state.schoolTypes = action.payload;
    },
    setSchoolOwners: (state, action: PayloadAction<any[]>) => {
      state.schoolOwners = action.payload;
    },
    setFilters: (state, action: PayloadAction<any>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = { search: '' };
    },
    setPagination: (state, action: PayloadAction<any>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
});

export const { 
  setSchools, 
  setSelectedSchool, 
  setSchoolLevels, 
  setSchoolTypes, 
  setSchoolOwners, 
  setFilters, 
  clearFilters, 
  setPagination 
} = schoolsSlice.actions;

export default schoolsSlice.reducer;